import { message, Upload } from 'antd';
import Uploader, { UploaderProps } from './Uploader';
import { useTranslate } from '@tolgee/react';

export const accepts = ['jpg', 'jpeg', 'png'];

export interface ImageUploaderProps extends UploaderProps {}

function ImageUploader(props: ImageUploaderProps) {
  const { children, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <Uploader
      accept={accepts.map((_) => `.${_}`).join(',')}
      beforeUpload={(file) => {
        const uploadSizeLimit = 5 * 1024 * 1024;

        if (file.size > uploadSizeLimit) {
          message.warn(
            t('phrase.超出图片限制xM大小', { x: (uploadSizeLimit / 1024 / 1024).toFixed(2) }),
          );

          return Upload.LIST_IGNORE;
        }

        return Promise.resolve();
      }}
      {...otherProps}
    >
      {children}
    </Uploader>
  );
}

export default ImageUploader;
